<template>
    <div class="article-class-suggest-edit">
        <p>
            <strong>Something look wrong?</strong>
            <br />Suggest a <nuxt-link to="/contact">change here</nuxt-link>.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleClassSuggestEdit',
};
</script>
